/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPrescription } from 'app/shared/model/prescription.model';
import { ILabPrescription } from 'app/shared/model/lab-prescription.model';
import { IRadiologyStudy } from 'app/shared/model/radiology-study.model';
import { IParamedic } from 'app/shared/model/paramedic.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { PatientType } from 'app/shared/model/enumerations/patient-type.model';

export interface IParamedicOrder {
  id?: string;
  active?: boolean | null;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  patientType?: keyof typeof PatientType | null;
  visitId?: string | null;
  prescription?: IPrescription | null;
  labPrescription?: ILabPrescription | null;
  radiologyStudy?: IRadiologyStudy | null;
  paramedic?: IParamedic | null;
  patient?: IGlucoUser | null;
}

export const defaultValue: Readonly<IParamedicOrder> = {
  active: false,
};
